// removed by extract-text-webpack-plugin
module.exports = {"list":"_2JwYR9n","list__animate":"DfrfywO","carouselLink":"_1Fg6Mkn"};


//////////////////
// WEBPACK FOOTER
// ./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/index.css
// module id = ./template/components/Navigation/SideNavigationContainer/CarouselContainer/Carousel/index.css
// module chunks = client.sitechrome